<div [hidden]="!loader()">
    <form autocomplete="off" #renewForm="ngForm" class="uk-margin-small-bottom uk-text-left" novalidate>
        <!-- step 1 -->
        <section class="uk-section uk-position-relative" uk-height-viewport *ngIf="form_first()">
            <div style="margin-bottom: 130px;">
                <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
                    <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
                        <div class="uk-container uk-container-small">
                            <div class="uk-card uk uk-card-body" style="padding-bottom: 0px;">
                                <div class="uk-child-width-1-2" uk-grid>
                                    <div>
                                        <circle-progress [percent]="25.00" [radius]="30" [space]="-10"
                                            [outerStrokeGradient]="true" [outerStrokeWidth]="10"
                                            [outerStrokeColor]="style.Circle"
                                            [outerStrokeGradientStopColor]="style.Circle" [innerStrokeColor]="'#e7e8ea'"
                                            [innerStrokeWidth]="10" [title]="'1/4'" [titleFontWeight]="600"
                                            [titleFontSize]="17" [showUnits]="false" [showSubtitle]="false">
                                        </circle-progress>
                                    </div>
                                    <div style="padding: 30px 0px 0px 0px">
                                        <label class="uk-form-label"
                                            style="font-size: 0.9rem !important; float: right; font-weight: bold; font-style: italic">เลือกผลิตภัณฑ์ประกันภัย</label>
                                        <br />
                                        <label class="uk-form-label"
                                            style="font-size: 0.7rem !important; float: right;">ถัดไป :
                                            ประกันคุ้มครองเพิ่มเติม</label>
                                        <br />
                                    </div>
                                </div>

                                <div style="padding: 10px 0px 0px 0px;">
                                    <div>
                                        <label class="uk-form-label"
                                            style="font-size: 1.3rem !important; font-style: oblique;"
                                            [ngStyle]="{'color': style.Circle}">เลือกผลิตภัณฑ์ประกันภัย</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="insuredetail_data.product_family_flag == 2">
                    <div style="padding: 0 20px 10px 20px;">
                        <hr style="margin-bottom: 8px;">
                        <label class="uk-form-label" style="font-size: 0.8rem !important; color: #555;">หมายเลขอ้างอิง :
                            {{insuredetail_data.refNo || ''}}</label>
                        <div uk-grid>
                            <div class="uk-width-auto">
                                <label class="uk-form-label"
                                    style="font-size: 1.0rem !important; font-style: oblique; color: #333;">ผู้เอาประกันภัยจำนวน</label>
                            </div>
                            <div class="uk-width-expand" style="text-align: right;">
                                <label class="uk-form-label"
                                    style="font-size: 1.0rem !important; font-style: oblique; color: #333;">{{insuredetail_data.main_protection
                                    ? insuredetail_data.main_protection.length : '-'}} ท่าน</label>
                            </div>
                        </div>
                    </div>
                    <div style="padding: 10px 20px; width: auto;" [ngStyle]="{'background-color': style.BG}">
                        <div uk-grid>
                            <div class="uk-width-auto">
                                <label class="uk-form-label"
                                    style="font-size: 1.0rem !important; font-style: oblique; color: #333;">ยอดชำระเต็มจำนวน</label>
                            </div>
                            <div class="uk-width-expand" style="text-align: right;">
                                <label class="uk-form-label"
                                    style="font-size: 1.2rem !important; font-style: oblique; color: #333;">{{numberWithCommas(total_amount())}}
                                    บาท</label>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div uk-grid style="padding: 10px 20px 10px 20px;">
                            <div class="uk-width-auto">
                                <label class="uk-form-label detail-text">ชำระรายเดือน โดยชำระครั้งเเรก</label>
                            </div>
                            <div class="uk-width-expand" style="text-align: right; padding-left: 10px;">
                                <label class="uk-form-label detail-text oblique">{{numberWithCommas(first_month_total())}}
                                    บาท</label>
                            </div>
                        </div>
                        <hr style="margin: 10px 0;">
                        <div uk-grid style="padding: 0 20px 10px 20px;">
                            <div class="uk-width-auto">
                                <label class="uk-form-label detail-text">
                                    ชำระครั้งถัดไปทุกวันที่ {{insuredetail_data.payment_date ?
                                    insuredetail_data.payment_date : '-'}} ของเดือน
                                </label>
                            </div>
                            <div class="uk-width-expand" style="text-align: right; padding-left: 10px;">
                                <label class="uk-form-label detail-text oblique">{{numberWithCommas(monthly_premium())}}
                                    บาท</label>
                            </div>
                        </div>
                        <hr style="margin: 10px 0;">
                    </div>
                    <div style="padding: 10px 20px 10px 20px;">
                        <label
                            class="uk-form-label subtitle-text oblique">เลือกผลิตภัณฑ์ประกันภัยที่ต้องการต่ออายุ</label>
                        <br>
                        <label><input class="uk-checkbox" type="checkbox" (click)="clickCheckAll('main')"
                                [checked]="check_all_main()"> เลือกผลิตภัณฑ์ทั้งหมด</label>
                    </div>
                </div>
                <div *ngFor="let item of insuredetail_data.main_protection; let i = index;">
                    <div style="padding: 10px 20px 10px 20px; width: auto;"
                        [ngStyle]="{'background-color': style.Button}">
                        <div style="margin-top: 0px !important" uk-grid>
                            <div class="uk-width-auto">
                                <label class="uk-form-label"
                                    style="font-size: 0.7rem !important; color: white;">ผู้เอาประกันภัย</label>
                            </div>
                            <div class="uk-width-expand">
                                <label *ngIf="insuredetail_data.product_family_flag == 1" class="uk-form-label"
                                    style="font-size: 0.7rem !important; word-wrap: break-word; float: right; color: white;">หมายเลขอ้างอิง
                                    :
                                    {{insuredetail_data.refNo || ''}}</label>
                            </div>
                        </div>
                        <div>
                            <label class="uk-form-label"
                                style="font-size: 1.3rem !important; font-style: oblique; color: white;">{{item[0].name
                                ||''}}</label>
                        </div>
                        <br>
                        <div style="margin-top: 0px !important" uk-grid>
                            <div class="uk-width-auto">
                                <label class="uk-form-label"
                                    style="font-size: 1.0rem !important; font-style: oblique; color: white;">ค่าเบี้ยประกันภัยรวม</label>
                            </div>
                            <div class="uk-width-expand">
                                <label class="uk-form-label"
                                    style="font-size: 1.0rem !important; word-wrap: break-word; font-style: oblique; float: right; color: white;">{{calculateTotalPricePerPerson(i)}}
                                    บาท</label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="insuredetail_data.product_family_flag == 1">
                        <div>
                            <div uk-grid style="padding: 10px 20px 10px 20px;">
                                <div class="uk-width-auto">
                                    <label class="uk-form-label detail-text">ชำระรายเดือน โดยชำระครั้งเเรก</label>
                                </div>
                                <div class="uk-width-expand" style="text-align: right; padding-left: 10px;">
                                    <label
                                        class="uk-form-label detail-text oblique">{{numberWithCommas(first_month_total())}}
                                        บาท</label>
                                </div>
                            </div>
                            <hr style="margin: 10px 0;">
                            <div uk-grid style="padding: 0 20px 10px 20px;">
                                <div class="uk-width-auto">
                                    <label class="uk-form-label detail-text">
                                        ชำระครั้งถัดไปทุกวันที่ {{insuredetail_data.payment_date ?
                                        insuredetail_data.payment_date : '-'}} ของเดือน
                                    </label>
                                </div>
                                <div class="uk-width-expand" style="text-align: right; padding-left: 10px;">
                                    <label
                                        class="uk-form-label detail-text oblique">{{numberWithCommas(monthly_premium())}}
                                        บาท</label>
                                </div>
                            </div>
                            <hr style="margin: 10px 0;">
                        </div>
                        <div style="padding: 10px 20px 0 20px;">
                            <label
                                class="uk-form-label subtitle-text oblique">เลือกผลิตภัณฑ์ประกันภัยที่ต้องการต่ออายุ</label>
                            <br>
                            <label><input class="uk-checkbox" type="checkbox" (click)="clickCheckAll('main')"
                                    [checked]="check_all_main()"> เลือกผลิตภัณฑ์ทั้งหมด</label>
                        </div>
                    </div>
                    <div *ngFor="let insure of item; let j = index;">
                        <div style="margin:12px 16px; border: 1px solid #e5e5e5; box-shadow: none;"
                            class="uk-card uk-card-default uk-border-rounded">
                            <div style="padding:8px;">
                                <div uk-grid (click)="clickAdditionalOption(i,j,'main')">
                                    <div class="uk-width-1-3">
                                        <div uk-grid>
                                            <div class="uk-width-1-3" style="align-self: center;">
                                                <input class="uk-checkbox" type="checkbox" [checked]="insure.checked">
                                            </div>
                                            <div class="uk-width-2-3" style="align-self: center;">
                                                <div class="circular--logo">
                                                    <img src="images/{{insure.logo}}">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="uk-width-2-3" style="padding-left: 5px;">
                                        <label class="uk-form-label"
                                            style="font-size: 0.7rem !important; color: #70757a;">{{insure.group_name}}</label>
                                        <br />
                                        <label class="uk-form-label"
                                            style="font-size: 0.9rem !important; color: #333;">{{insure.product_name}}</label>
                                        <br />
                                        <div uk-grid>
                                            <div class="uk-width-auto">
                                                <label class="uk-form-label"
                                                    style="font-size: 0.9rem !important; color: #333;">{{insure.plan ||
                                                    '-'}}</label>
                                            </div>
                                            <div class="uk-width-expand" style="text-align: right; padding-left: 10px;">
                                                <label class="uk-form-label"
                                                    style="font-size: 0.9rem !important; color: #333; font-weight: bold;">{{numberWithCommas(insure.premium)
                                                    || '-'}} บาท</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div *ngIf="insuredetail_data.main_protection.length > 0"
                    style="padding: 10px 10px 10px 10px; background-color: #f4f4f4; line-height: 17px; margin: 10px 20px 10px 20px; text-align: left;">
                    <label class="uk-form-label"
                        style="font-size: 0.7rem !important; color: red; word-wrap: break-word;">
                        ยอดค่าเบี้ยประกันภัยรวมจะเปลี่ยนแปลงไปตามผลิตภัณฑ์ประกันภัยที่ท่านเลือก
                    </label>
                </div>
                <hr style="margin: 10px 20px;">
                <div style="padding: 5px 0 50px 0;" class="uk-flex uk-flex-center uk-padding-remove-horizontal">
                    <button type="submit" class="uk-button uk-button-primary uk-border-rounded +btn-min-160"
                        style="min-width: 300px !important;" [ngStyle]="{'background-color': style.Button}"
                        (click)="onNextStep('toSecond')"
                        [disabled]="insuredetail_data.main_protection.length == 0 || !has_checked() || total_amount() == 0">ถัดไป
                    </button>
                </div>
            </div>
        </section>
        <!-- end step one -->
        <!-- step two -->
        <section class="uk-section uk-position-relative" uk-height-viewport *ngIf="form_second()">
            <div style="margin-bottom: 130px;">
                <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
                    <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
                        <div class="uk-container uk-container-small">
                            <div class="uk-card uk uk-card-body" style="padding-bottom: 0px;">
                                <div class="uk-child-width-1-2" uk-grid>
                                    <div>
                                        <circle-progress [percent]="50.00" [radius]="30" [space]="-10"
                                            [outerStrokeGradient]="true" [outerStrokeWidth]="10"
                                            [outerStrokeColor]="style.Circle"
                                            [outerStrokeGradientStopColor]="style.Circle" [innerStrokeColor]="'#e7e8ea'"
                                            [innerStrokeWidth]="10" [title]="'2/4'" [titleFontWeight]="600"
                                            [titleFontSize]="17" [showUnits]="false" [showSubtitle]="false">
                                        </circle-progress>
                                    </div>
                                    <div style="padding: 30px 0px 0px 0px">
                                        <label class="uk-form-label"
                                            style="font-size: 0.9rem !important; float: right; font-weight: bold; font-style: italic">เลือกผลิตภัณฑ์ประกันภัย</label>
                                        <br />
                                        <label class="uk-form-label"
                                            style="font-size: 0.7rem !important; float: right;">ถัดไป :
                                            วิธีการชำระเงิน</label>
                                        <br />
                                    </div>
                                </div>

                                <div style="padding: 10px 0px 0px 0px;">
                                    <div>
                                        <label class="uk-form-label"
                                            style="font-size: 1.3rem !important; font-style: oblique;"
                                            [ngStyle]="{'color': style.Circle}">เลือกผลิตภัณฑ์ประกันภัยเพิ่มเติม</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="insuredetail_data.product_family_flag == 2">
                    <div style="padding: 0 20px 10px 20px;">
                        <hr style="margin-bottom: 8px;">
                        <label class="uk-form-label" style="font-size: 0.8rem !important; color: #555;">หมายเลขอ้างอิง :
                            {{insuredetail_data.refNo || ''}}</label>
                        <div uk-grid>
                            <div class="uk-width-auto">
                                <label class="uk-form-label"
                                    style="font-size: 1.0rem !important; font-style: oblique; color: #333;">ผู้เอาประกันภัยจำนวน</label>
                            </div>
                            <div class="uk-width-expand" style="text-align: right;">
                                <label class="uk-form-label"
                                    style="font-size: 1.0rem !important; font-style: oblique; color: #333;">{{insuredetail_data.main_protection
                                    ? insuredetail_data.main_protection.length : '-'}} ท่าน</label>
                            </div>
                        </div>
                    </div>
                    <div style="padding: 10px 20px; width: auto;" [ngStyle]="{'background-color': style.BG}">
                        <div uk-grid>
                            <div class="uk-width-auto">
                                <label class="uk-form-label"
                                    style="font-size: 1.0rem !important; font-style: oblique; color: #333;">ยอดชำระเต็มจำนวน</label>
                            </div>
                            <div class="uk-width-expand" style="text-align: right;">
                                <label class="uk-form-label"
                                    style="font-size: 1.2rem !important; font-style: oblique; color: #333;">{{numberWithCommas(total_amount())}}
                                    บาท</label>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div uk-grid style="padding: 10px 20px 10px 20px;">
                            <div class="uk-width-auto">
                                <label class="uk-form-label detail-text">ชำระรายเดือน โดยชำระครั้งเเรก</label>
                            </div>
                            <div class="uk-width-expand" style="text-align: right; padding-left: 10px;">
                                <label class="uk-form-label detail-text oblique">{{numberWithCommas(first_month_total())}}
                                    บาท</label>
                            </div>
                        </div>
                        <hr style="margin: 10px 0;">
                        <div uk-grid style="padding: 0 20px 10px 20px;">
                            <div class="uk-width-auto">
                                <label class="uk-form-label detail-text">
                                    ชำระครั้งถัดไปทุกวันที่ {{insuredetail_data.payment_date ?
                                    insuredetail_data.payment_date : '-'}} ของเดือน
                                </label>
                            </div>
                            <div class="uk-width-expand" style="text-align: right; padding-left: 10px;">
                                <label class="uk-form-label detail-text oblique">{{numberWithCommas(monthly_premium())}}
                                    บาท</label>
                            </div>
                        </div>
                        <hr style="margin: 10px 0;">
                    </div>
                    <div style="padding: 10px 20px 10px 20px;">
                        <label class="uk-form-label subtitle-text oblique">เลือกประกันคุ้มครองเพิ่มเติม</label>
                        <br>
                        <label><input class="uk-checkbox" type="checkbox" (click)="clickCheckAll('second')"
                                [checked]="check_all_second()"> เลือกผลิตภัณฑ์ทั้งหมด</label>
                    </div>
                </div>
                <div *ngFor="let item of insuredetail_data.main_protection; let i = index;">
                    <div style="padding: 10px 20px 10px 20px; width: auto;"
                        [ngStyle]="{'background-color': style.Button}">
                        <div style="margin-top: 0px !important" uk-grid>
                            <div class="uk-width-auto">
                                <label class="uk-form-label"
                                    style="font-size: 0.7rem !important; color: white;">ผู้เอาประกันภัย</label>
                            </div>
                            <div class="uk-width-expand">
                                <label *ngIf="insuredetail_data.product_family_flag == 1" class="uk-form-label"
                                    style="font-size: 0.7rem !important; word-wrap: break-word; float: right; color: white;">หมายเลขอ้างอิง
                                    :
                                    {{insuredetail_data.refNo || ''}}</label>
                            </div>
                        </div>
                        <div>
                            <label class="uk-form-label"
                                style="font-size: 1.3rem !important; font-style: oblique; color: white;">{{item[0].name
                                ||''}}</label>
                        </div>
                        <br>
                        <div style="margin-top: 0px !important" uk-grid>
                            <div class="uk-width-auto">
                                <label class="uk-form-label"
                                    style="font-size: 1.0rem !important; font-style: oblique; color: white;">ค่าเบี้ยประกันภัยรวม</label>
                            </div>
                            <div class="uk-width-expand">
                                <label class="uk-form-label"
                                    style="font-size: 1.0rem !important; word-wrap: break-word; font-style: oblique; float: right; color: white;">{{calculateTotalPricePerPerson(i)}}
                                    บาท</label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="insuredetail_data.product_family_flag == 1">
                        <div>
                            <div uk-grid style="padding: 10px 20px 10px 20px;">
                                <div class="uk-width-auto">
                                    <label class="uk-form-label detail-text">ชำระรายเดือน โดยชำระครั้งเเรก</label>
                                </div>
                                <div class="uk-width-expand" style="text-align: right; padding-left: 10px;">
                                    <label
                                        class="uk-form-label detail-text oblique">{{numberWithCommas(first_month_total())}}
                                        บาท</label>
                                </div>
                            </div>
                            <hr style="margin: 10px 0;">
                            <div uk-grid style="padding: 0 20px 10px 20px;">
                                <div class="uk-width-auto">
                                    <label class="uk-form-label detail-text">
                                        ชำระครั้งถัดไปทุกวันที่ {{insuredetail_data.payment_date ?
                                        insuredetail_data.payment_date : '-'}} ของเดือน
                                    </label>
                                </div>
                                <div class="uk-width-expand" style="text-align: right; padding-left: 10px;">
                                    <label
                                        class="uk-form-label detail-text oblique">{{numberWithCommas(monthly_premium())}}
                                        บาท</label>
                                </div>
                            </div>
                            <hr style="margin: 10px 0;">
                        </div>
                        <div style="padding: 10px 20px 0 20px;">
                            <label class="uk-form-label subtitle-text oblique">เลือกประกันคุ้มครองเพิ่มเติม</label>
                            <br>
                            <label *ngIf="insuredetail_data.second_protection[i]"><input class="uk-checkbox"
                                    type="checkbox" (click)="clickCheckAll('second')" [checked]="check_all_second()">
                                เลือกผลิตภัณฑ์ทั้งหมด</label>
                            <label *ngIf="!insuredetail_data.second_protection[i]">-</label>
                        </div>
                    </div>
                    <div *ngFor="let insure of insuredetail_data.second_protection[i]; let j = index;">
                        <div style="margin:12px 16px; border: 1px solid #e5e5e5; box-shadow: none;"
                            class="uk-card uk-card-default uk-border-rounded">
                            <div style="padding:8px;">
                                <div uk-grid (click)="clickAdditionalOption(i,j,'second')">
                                    <div class="uk-width-1-3">
                                        <div uk-grid>
                                            <div class="uk-width-1-3" style="align-self: center;">
                                                <input class="uk-checkbox" type="checkbox" [checked]="insure.checked">
                                            </div>
                                            <div class="uk-width-2-3" style="align-self: center;">
                                                <div class="circular--logo">
                                                    <img src="images/{{insure.logo}}">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="uk-width-2-3" style="padding-left: 5px;">
                                        <div class="uk-margin uk-child-width-auto uk-grid" style="margin: 0px;">
                                            <label class="uk-form-label"
                                                style="font-size: 0.7rem !important; color: #70757a; padding-left: 0; align-self: flex-end;">{{insure.group_name}}</label>
                                            <div style="padding-right: 5px; width: 60 px; margin-left: auto; align-items:center;"
                                                (click)="clickAdditionalOption(i,j,'second')">
                                                <a class="black-icon" uk-icon="info"
                                                    style="size: 42px; color:black; cursor: pointer; margin-left: 8px;"
                                                    href="#modal-card-mf-{{j}}" uk-toggle></a>
                                                <div id="modal-card-mf-{{j}}" uk-modal>
                                                    <div class="uk-modal-dialog"
                                                        style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                                                        <div
                                                            style="background-color: white; padding-bottom: 10px; margin: 10px;">
                                                            <button class="uk-modal-close-default" type="button"
                                                                uk-close></button>
                                                            <div class="uk-modal-header" style="padding: 10px 20px;">
                                                                <div
                                                                    style="font-size: 1.2 rem !important; padding: 0px;">
                                                                    รายละเอียดความคุ้มครอง</div>
                                                            </div>
                                                            <div class="uk-modal-body"
                                                                style="padding: 10px 20px 0 20px; max-height: 400px; overflow: auto;">
                                                                <div *ngIf="!(insure && insure.protection_detail)"
                                                                    style="margin: 0;" class="uk-flex">-
                                                                </div>
                                                                <div *ngIf="insure && insure.protection_detail">
                                                                    <div style="text-align: left;">
                                                                        <label class="uk-form-label "
                                                                            style="font-size: 0.8rem !important; ">{{insure.protection_category}}</label>
                                                                    </div>
                                                                    <table class="uk-table uk-table-striped"
                                                                        style="margin: 10px 0;">
                                                                        <tbody>
                                                                            <tr class="uk-table-expand"
                                                                                *ngFor="let protect of insure.protection_detail">
                                                                                <td class="uk-width-2-3 uk-padding-remove-right"
                                                                                    style="text-align: left; font-size: 0.7rem !important;">
                                                                                    {{protect.protection_name}}</td>
                                                                                <td class="uk-width-1-3"
                                                                                    style="text-align: right; font-size: 0.7rem !important;">
                                                                                    {{protect.protection_value}}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <label class="uk-form-label"
                                            style="font-size: 0.9rem !important; color: #333;">{{insure.product_name}}</label>
                                        <br />
                                        <div uk-grid>
                                            <div class="uk-width-auto">
                                                <label class="uk-form-label"
                                                    style="font-size: 0.9rem !important; color: #333;">{{insure.plan ||
                                                    '-'}}</label>
                                            </div>
                                            <div class="uk-width-expand" style="text-align: right; padding-left: 10px;">
                                                <label class="uk-form-label"
                                                    style="font-size: 0.9rem !important; color: #333; font-weight: bold;">{{numberWithCommas(insure.premium)
                                                    || '-'}} บาท</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div *ngIf="insuredetail_data.second_protection.length > 0"
                    style="padding: 10px 10px 10px 10px; background-color: #f4f4f4; line-height: 17px; margin: 10px 20px 10px 20px; text-align: left;">
                    <label class="uk-form-label"
                        style="font-size: 0.7rem !important; color: red; word-wrap: break-word;">
                        ยอดค่าเบี้ยประกันภัยรวมจะเปลี่ยนแปลงไปตามผลิตภัณฑ์ประกันภัยที่ท่านเลือก
                    </label>
                </div>
                <hr style="margin: 10px 20px;">
                <div class="uk-border-rounded uk-overflow-hidden">
                    <div class="uk-container uk-container-small">
                        <div class="uk-card">
                            <div style="padding: 5px 0 50px 0;"
                                class="uk-flex uk-flex-center uk-padding-remove-horizontal">
                                <button type="submit"
                                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                                    style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px;background-color: white !important; border: 1px solid;"
                                    [ngStyle]="{'border-color': style.Button, 'color': style.Button}"
                                    (click)="onNextStep('toFirst')">ย้อนกลับ
                                </button>
                                <button type="submit"
                                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                                    style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px;"
                                    [ngStyle]="{'background-color': style.Button}" (click)="onNextStep('toThird')">ถัดไป
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- end step two -->
        <!-- step three -->
        <section class="uk-section uk-position-relative" uk-height-viewport *ngIf="form_third()">
            <div style="margin-bottom: 85px;">
                <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
                    <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
                        <div class="uk-container uk-container-small">
                            <div class="uk-card" style="padding-bottom: 0px; height: 90vh;">
                                <div class="uk-child-width-1-2" uk-grid>
                                    <div>
                                        <circle-progress [percent]="75.00" [radius]="30" [space]="-10"
                                            [outerStrokeGradient]="true" [outerStrokeWidth]="10"
                                            [outerStrokeColor]="style.Circle"
                                            [outerStrokeGradientStopColor]="style.Circle" [innerStrokeColor]="'#e7e8ea'"
                                            [innerStrokeWidth]="10" [title]="'3/4'" [titleFontWeight]="600"
                                            [titleFontSize]="17" [showUnits]="false" [showSubtitle]="false">
                                        </circle-progress>
                                    </div>
                                    <div style="padding: 30px 0px 0px 0px">
                                        <label class="uk-form-label"
                                            style="font-size: 0.9rem !important; float: right; font-weight: bold; font-style: italic">เลือกผลิตภัณฑ์ประกันภัย</label>
                                        <br />
                                        <label class="uk-form-label"
                                            style="font-size: 0.7rem !important; float: right;">ถัดไป :
                                            ที่อยู่จัดส่งเอกสาร</label>
                                        <br />
                                    </div>
                                </div>
                                <div style="padding: 10px 0px 10px 0px;">
                                    <div>
                                        <label class="uk-form-label"
                                            style="font-size: 1.3rem !important; font-style: oblique;"
                                            [ngStyle]="{'color': style.Circle}">เลือกวิธีการชำระเงิน</label>
                                    </div>
                                </div>
                                <div
                                    style="padding: 10px 0px 10px 0px; margin: 10px 0px 0px 0px; border: 2px solid; border-color:lightgrey; border-radius: 5px;">
                                    <div style="padding: 10px; font-size: 0.8rem;">
                                        <div style="align-items: center;" uk-grid (click)="onClickFullPay()">
                                            <div class="uk-width-auto">
                                                <input class="uk-checkbox" type="checkbox" style="border-radius: 20%;"
                                                    [checked]="checkBoxFullPay()">
                                            </div>
                                            <div class="uk-width-expand" style="padding: 0px 0px 0px 10px;">
                                                <div style="margin:0px;" uk-grid>
                                                    <div class="uk-width-auto" style="margin: 0px; padding: 0px;">
                                                        ชำระงวดเดียว</div>
                                                    <div class="uk-width-expand" style="margin: 0px;">
                                                        {{numberWithCommas(total_amount())}} บาท</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="installmentStatus()" uk-grid>
                                    <div class="uk-width-expand">
                                        <div
                                            style="padding: 0px 0px 0px 0px; margin: 10px 0px 10px 0px; border: 2px solid; border-color:lightgrey; border-radius: 5px;">
                                            <div class="uk-grid" style="margin: 0px;" (click)="onClickInstallment()">
                                                <div style="padding: 10px; font-size: 0.8rem;">
                                                    <div style="align-items: center;" uk-grid>
                                                        <div class="uk-width-auto">
                                                            <input class="uk-checkbox" type="checkbox"
                                                                style="border-radius: 20%;"
                                                                [checked]="checkBokInstallment()">
                                                        </div>
                                                        <div class="uk-width-expand" style="padding: 0px 0px 0px 10px;">
                                                            <div style="margin:0px;" uk-grid>
                                                                <div class="uk-width-auto"
                                                                    style="margin: 0px; padding: 0px;"> ผ่อนชำระ
                                                                    {{installmentData().length}} งวด</div>
                                                                <div class="uk-width-auto"
                                                                    style="margin: 0px; padding: 0px 0px 0px 10px;">
                                                                    งวดที่ 1</div>
                                                                <div class="uk-width-expand"
                                                                    style="margin: 0px; padding: 0px 0px 0px 10px;">
                                                                    {{numberWithCommas(installmentData()[0].value)}} บาท
                                                                </div>
                                                            </div>
                                                            <p style="color: red; font-size: 0.7rem; margin: 0px;">
                                                                *สามารถดูตารางผ่อนชำระโดยกดปุ่มด้านข้าง
                                                                <br>
                                                                *ยอดนี้ต้องชำระก่อนวันที่
                                                                {{convertDateThai(installmentData()[0].date)}} เท่านั้น
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    style="padding: 10px 10px 0px 5px ; width: 60 px; margin-left: auto;">
                                                    <!-- <span uk-icon="info" style="color: black; size: 50px;"></span> -->
                                                    <span uk-icon="info" class="tooltip"
                                                        style="size: 50px; color:black; cursor: pointer;"
                                                        (click)="onClickInstallment()">
                                                        <div class="tooltiptext tooltip-position1"
                                                            style="line-height: 0.9rem;">
                                                            <div>
                                                                <img src="https://services.tiscoinsure.com/contents/images/Header-TISCO-Insure.png"
                                                                    style="width: 100%;">
                                                                <label class="uk-form-label"
                                                                    style="font-size: 0.8rem !important; font-weight: bold; white-space: nowrap; position: absolute; color:white; right: 155px; padding-top: 10px;">แบ่งชำระรายเดือน</label>
                                                            </div>
                                                            <div uk-grid>
                                                                <div class="uk-width-1-1"
                                                                    style="font-size: 1.0rem; font-weight: bold; margin: 10px 0px 10px 0px;">
                                                                    {{installmentData().length}} เดือน
                                                                    <hr style="margin-top: 10px;">
                                                                </div>

                                                                <div class="uk-width-1-2"
                                                                    style="font-size: 0.7rem; margin: 5px 0px 5px 0px;">
                                                                    ยอดชำระต่อเดือน </div>
                                                                <div class="uk-width-1-2"
                                                                    style="font-size: 0.7rem; font-weight: bold; margin: 5px 0px 5px 0px; text-align: right;">
                                                                    {{numberWithCommas(installmentData()[0].value)}} บาท
                                                                </div>
                                                                <div class="uk-width-1-2"
                                                                    style="font-size: 0.7rem; margin: 5px 0px 5px 0px;">
                                                                    วันชำระเงินงวดแรก </div>
                                                                <div class="uk-width-1-2"
                                                                    style="font-size: 0.7rem; font-weight: bold; margin: 5px 0px 5px 0px; text-align: right;">
                                                                    {{convertDateThai(installmentData()[0].date)}} </div>

                                                                <div class="uk-width-1-1"
                                                                    *ngFor="let data of installmentData(); let i = index"
                                                                    style="margin: 0px;">
                                                                    <div style="margin: 0px;" *ngIf="i != 0">
                                                                        <hr style="margin: 5px 0px 5px 0px;">
                                                                        <div uk-grid>
                                                                            <div class="uk-width-auto"
                                                                                style="font-size: 0.7rem; margin: 5px 0px 5px 0px;">
                                                                                ชำระงวดที่ {{i+1}}
                                                                                {{convertDateThai(data.date)}}
                                                                            </div>
                                                                            <div class="uk-width-expand"
                                                                                style="font-size: 0.7rem; font-weight: bold; margin: 5px 0px 5px 0px; text-align: right;">
                                                                                {{numberWithCommas(data.value)}} บาท
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div
                    style="padding: 10px 0px 10px 20px; margin: 0 15px; font-size: 0.7rem; color: red; background-color: #f4f4f4; text-align: left;">
                    * ถ้าไม่ชำระก่อนวันที่แจ้งเบี้ยอาจมีการเปลี่ยนแปลง
                </div>
                <hr style="margin: 10px 20px;">
                <div class="uk-border-rounded uk-overflow-hidden">
                    <div class="uk-container uk-container-small">
                        <div class="uk-card">
                            <div style="padding: 5px 0 50px 0;"
                                class="uk-flex uk-flex-center uk-padding-remove-horizontal">
                                <button type="submit"
                                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                                    style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px;background-color: white !important; border: 1px solid;"
                                    [ngStyle]="{'border-color': style.Button, 'color': style.Button}"
                                    (click)="onNextStep('toSecond')">ย้อนกลับ
                                </button>
                                <button type="submit"
                                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                                    style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px;"
                                    [ngStyle]="{'background-color': style.Button}"
                                    (click)="onNextStep('toFourth')">ถัดไป
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- end step three -->
        <!-- step four -->
        <section class="uk-section uk-position-relative" uk-height-viewport *ngIf="form_fourth() && !editAddr()">
            <div style="margin-bottom: 85px;">
                <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
                    <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
                        <div class="uk-container uk-container-small">
                            <div class="uk-card uk uk-card-body">
                                <div class="uk-child-width-1-2" uk-grid>
                                    <div>
                                        <circle-progress [percent]="100" [radius]="30" [space]="-10"
                                            [outerStrokeGradient]="true" [outerStrokeWidth]="10"
                                            [outerStrokeColor]="style.Circle"
                                            [outerStrokeGradientStopColor]="style.Circle" [innerStrokeColor]="'#e7e8ea'"
                                            [innerStrokeWidth]="10" [title]="'4/4'" [titleFontWeight]="600"
                                            [titleFontSize]="17" [showUnits]="false" [showSubtitle]="false">
                                        </circle-progress>
                                    </div>
                                    <div style="padding-top: 40px">
                                        <label class="uk-form-label"
                                            style="font-size: 0.9rem !important; float: right; font-weight: bold; font-style: italic">ที่อยู่จัดส่งเอกสาร</label>
                                        <br />
                                        <label class="uk-form-label"
                                            style="font-size: 0.7rem !important; float: right; font-style: italic"></label>
                                        <br />
                                    </div>
                                </div>
                                <div class="hline"></div>
                                <div>
                                    <label class="uk-form-label"
                                        style="font-size: 1rem !important; font-weight: bold; font-style: italic">ที่อยู่ปัจจุบัน
                                        <span
                                            style="font-size: 0.7rem !important; font-weight: lighter; font-style: normal">(กรมธรรม์เดิม)</span></label>
                                    <br />
                                    <br />
                                </div>
                                <div>
                                    <label class="uk-form-label"
                                        style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">ที่อยู่<span
                                            uk-icon="file-edit" style="float: right; cursor: pointer; color: #3fbfb9;"
                                            (click)="onEditAddr()"></span></label>
                                    <br />
                                </div>
                                <div>
                                    <label class="uk-form-label"
                                        style="font-size: 0.8rem !important; font-weight: normal; word-wrap: break-word;">{{insuredetail_data.address}}</label>
                                </div>
                                <div class="hline"></div>
                                <div>
                                    <label class="uk-form-label"
                                        style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">เบอร์โทรศัพท์<span
                                            uk-icon="file-edit" style="float: right; cursor: pointer; color: #3fbfb9;"
                                            (click)="onEditTel()"></span></label>
                                    <br />
                                </div>
                                <div *ngIf="!editTel()">
                                    <label class="uk-form-label"
                                        style="font-size: 0.8rem !important; font-weight: normal; word-wrap: break-word;">{{insuredetail_data.phoneNo}}</label>
                                </div>
                                <div *ngIf="editTel()">
                                    <div>
                                        <input id="phone" #phone="ngModel" name="phone"
                                            class="uk-input uk-border-rounded" type="text"
                                            placeholder="ระบุเบอร์โทรศัพท์" [(ngModel)]="phoneValue"
                                            (change)="onInputPhone($event)" [ngClass]="addClass(renewForm,'phone')"
                                            mask="0000000009" required />
                                    </div>
                                    <br />
                                    <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal"
                                        style="padding-top: 0px; margin-top: 10px;">
                                        <button type="submit"
                                            class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                                            style="min-width: 140px !important; background-color: white;"
                                            [ngStyle]="{'border-color': style.Button, 'color': style.Button}"
                                            (click)="onCancelEditTel()">ยกเลิก
                                        </button>
                                        <button type="submit"
                                            class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                                            style="min-width: 140px !important; float: right"
                                            [ngStyle]="{'background-color': style.Button}" (click)="onSaveTel()"
                                            [disabled]="renewForm.invalid">บันทึก
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div
                    style="padding: 0px 10px 0px 10px; background-color: #f4f4f4; line-height: 17px; margin-top: 30px; text-align: left;">
                    <label class="uk-form-label"
                        style="font-size: 0.7rem !important; color: red; word-wrap: break-word;">*
                        โปรดตรวจสอบข้อมูลของท่านให้เรียบร้อยก่อนยืนยันข้อมูล
                        เพราะท่านจะไม่สามารถกลับมาแก้ไขข้อมูลได้อีก</label>
                </div>
                <hr style="margin: 10px 20px;">
                <div class="uk-border-rounded uk-overflow-hidden">
                    <div class="uk-container uk-container-small">
                        <div class="uk-card">
                            <div style="padding: 5px 0 50px 0;"
                                class="uk-flex uk-flex-center uk-padding-remove-horizontal">
                                <button type="submit"
                                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                                    style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px;background-color: white !important; border: 1px solid;"
                                    [ngStyle]="{'border-color': style.Button, 'color': style.Button}"
                                    (click)="onNextStep('toThird')">ย้อนกลับ
                                </button>
                                <button type="submit"
                                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                                    style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px;"
                                    [ngStyle]="{'background-color': style.Button}" (click)="onSubmit()">ยืนยันข้อมูล
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="uk-section uk-position-relative" uk-height-viewport *ngIf="form_fourth() && editAddr()">
            <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
                <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
                    <div class="uk-container uk-container-small" *ngIf="editAddr()">
                        <div class="uk-card uk uk-card-body">
                            <div class="uk-child-width-1-2" uk-grid>
                                <div>
                                    <label class="uk-form-label"
                                        style="font-size: 1.2rem !important; font-weight: bold; font-style: italic">แก้ไขที่อยู่จัดส่ง</label>
                                </div>
                                <div>
                                    <span uk-icon="close" style="cursor: pointer; float:right; color: black;"
                                        (click)="onCancelEditAddr()"></span>
                                </div>
                            </div>
                            <div class="hline"></div>
                            <form autocomplete="off" #f201="ngForm" (keydown.enter)="$event.preventDefault()">
                                <!-- สถานที่ จัดส่ง Start -->
                                <div>
                                    <label class="uk-form-label"
                                        style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">สถานที่จัดส่ง
                                        (เลขที่,อาคาร,ซอย,ถนน,แขวง)</label>
                                </div>
                                <div class="uk-form-controls uk-position-relative">
                                    <input [ngClass]="addClass(f201,'address')" class="uk-input uk-border-rounded"
                                        name="address" placeholder="ระบุสถานที่จัดส่ง" type="text"
                                        [(ngModel)]="addrValue1" required>
                                    <small [ngClass]="addClass(f201,'address','msg')"
                                        class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error">กรุณากรอกสถานที่จัดส่ง
                                        (เลขที่,อาคาร,ซอย,ถนน,แขวง)</small>
                                </div>
                                <!-- สถานที่ จัดส่ง End -->

                                <!-- ตำบล Start -->
                                <div>
                                    <label class="uk-form-label"
                                        style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">ตำบล
                                        / แขวง</label>
                                </div>
                                <div class="uk-form-controls uk-position-relative">
                                    <input class="uk-input uk-border-rounded" type="hidden"
                                        placeholder="ตำบล / แขวงที่คุณอยู่" value="" name="subDistrict"
                                        [(ngModel)]="model.address.current.subDistrict"
                                        [ngClass]="addClass(f201,'subDistrict')" required />
                                    <ng-autocomplete
                                    [data]="results['current.subDistrict']"
                                    [searchKeyword]="keyword"
                                    (selected)="onSelect2($event,'subDistrict','current')"
                                    (inputChanged)="onChangeSearch2($event,'subDistrict','current')"
                                    (inputCleared)="onClearSelect()"
                                    (inputFocused)='onFocused($event)'
                                    [itemTemplate]="itemsubDistrict"
                                    [notFoundTemplate]="notFoundTemplate"   
                                    name="subDistrictText"            
                                    [(ngModel)]="subDistrict"                            
                                    [isLoading]="isLoading['current.subDistrict']"
                                    placeholder="ตำบล / แขวง"
                                    ></ng-autocomplete>
                                    <ng-template #itemsubDistrict let-item>
                                        <a [innerHTML]="item.markup"></a>
                                        </ng-template>
                                        
                                        <ng-template #notFoundTemplate let-notFound>
                                        <div [innerHTML]="notFound"></div>
                                        </ng-template>
                                    <!-- <ng2-simple-autocomplete [(search)]="model.address.current.subDistrictText"
                                        [ngClass]="addClass(f201,'subDistrict')"
                                        [(model)]="model.address.current.subDistrict"
                                        [searchResults]="results['current.subDistrict']"
                                        (onSelect)="onSelect2($event,'subDistrict','current')"
                                        (onChangeInput)="onChangeSearch2($event,'subDistrict','current')"
                                        historyId="subDistrict" placeholder="ตำบล / แขวง" [maxHistory]="10">
                                    </ng2-simple-autocomplete> -->
                                    <small [ngClass]="addClass(f201,'subDistrict','msg')"
                                        class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error">กรุณากรอกตำบล
                                        /
                                        แขวงที่คุณอยู่</small>
                                </div>
                                <!-- ตำบล end -->

                                <!-- เขต/อำเภอ Start -->
                                <div>
                                    <label class="uk-form-label"
                                        style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">เขต/อำเภอ</label>
                                </div>
                                <div class="uk-form-controls uk-position-relative">
                                    <input class="uk-input uk-border-rounded" type="hidden"
                                        placeholder="อำเภอ / เขตที่คุณอยู่" value="" name="district"
                                        [(ngModel)]="model.address.current.district"
                                        [ngClass]="addClass(f201,'district')" required />

                                        <ng-autocomplete
                                        [ngClass]="addClass(f201,'district')"
                                        [data]="results['current.district']"
                                        [searchKeyword]="keyword"
                                        (selected)="onSelect2($event,'district','current')"
                                        (inputChanged)="onChangeSearch2($event,'district','current')"
                                        (inputFocused)='onFocused($event)'
                                        (inputCleared)="onClearSelect()"
                                        [itemTemplate]="itemDistrict"
                                        name="districtText"
                                        [(ngModel)]="district"                                
                                        [isLoading]="isLoading['current.district']"
                                        placeholder="อำเภอ / เขต"
                                        [notFoundTemplate]="notFoundTemplate"
                                        ></ng-autocomplete>
                                        <ng-template #itemDistrict let-item>
                                            <a [innerHTML]="item.markup"></a>
                                            </ng-template>
                                            
                                            <ng-template #notFoundTemplate let-notFound>
                                            <div [innerHTML]="notFound"></div>
                                            </ng-template>
                                    <!-- <ng2-simple-autocomplete [ngClass]="addClass(f201,'district')"
                                        [(search)]="model.address.current.districtText"
                                        [(model)]="model.address.current.district"
                                        [searchResults]="results['current.district']"
                                        (onSelect)="onSelect2($event,'district','current')"
                                        (onChangeInput)="onChangeSearch2($event,'district','current')"
                                        [isLoading]="isLoading['current.district']" historyId="district"
                                        placeholder="อำเภอ / เขต" [maxHistory]="0"></ng2-simple-autocomplete> -->

                                    <small [ngClass]="addClass(f201,'district','msg')"
                                        class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error">กรุณากรอกอำเภอ
                                        /
                                        เขตที่คุณอยู่</small>
                                </div>
                                <!-- เขต/อำเภอ End -->

                                <!-- จังหวัด Start -->
                                <div>
                                    <label class="uk-form-label"
                                        style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">จังหวัด</label>
                                </div>
                                <div class="uk-form-controls uk-position-relative">
                                    <input class="uk-input uk-border-rounded" type="hidden" id="province"
                                        placeholder="จังหวัดที่คุณอยู่" value="" name="province"
                                        [(ngModel)]="model.address.current.province"
                                        [ngClass]="addClass(f201,'province')" required />

                                        <ng-autocomplete
                                [ngClass]="addClass(f201,'province')"
                                [data]="results['current.province']"
                                [searchKeyword]="keyword"
                                (selected)="onSelect2($event,'province','current')"
                                (inputChanged)="onChangeSearch2($event,'province','current')"
                                (inputCleared)="onClearSelect()"
                                (inputFocused)='onFocused($event)'
                                [itemTemplate]="itemProvince"
                                name="provinceText"                                     
                                [(ngModel)]="province"                                
                                [isLoading]="isLoading['current.province']"
                                placeholder="จังหวัด"
                                [notFoundTemplate]="notFoundTemplate"
                                ></ng-autocomplete>
                                <ng-template #itemProvince let-item>
                                    <a [innerHTML]="item.markup"></a>
                                    </ng-template>
                                    
                                    <ng-template #notFoundTemplate let-notFound>
                                    <div [innerHTML]="notFound"></div>
                                    </ng-template>
                                    <!-- <ng2-simple-autocomplete [ngClass]="addClass(f201,'province')"
                                        [(search)]="model.address.current.provinceText"
                                        [(model)]="model.address.current.province"
                                        [searchResults]="results['current.province']"
                                        (onSelect)="onSelect2($event,'province','current')"
                                        (onChangeInput)="onChangeSearch2($event,'province','current')"
                                        [isLoading]="isLoading['current.province']" historyId="province"
                                        placeholder="จังหวัด" [maxHistory]="0"></ng2-simple-autocomplete> -->

                                    <small [ngClass]="addClass(f201,'province','msg')"
                                        class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error">กรุณากรอกจังหวัดที่คุณอยู่</small>
                                </div>
                                <!-- จังหวัด End -->

                                <!-- รหัสไปรษณีย์ Start -->
                                <div>
                                    <label class="uk-form-label"
                                        style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">รหัสไปรษณีย์</label>
                                </div>
                                <div class="uk-form-controls uk-position-relative">
                                    <input [ngClass]="addClass(f201,'postCode')" id="postCode1"
                                        class="uk-input uk-border-rounded uk-text-emphasis" type="text"
                                        placeholder="รหัสไปรษณีย์" maxlength="5" inputmode="decimal" [disabled]="true"
                                        name="postCode" #postCode="ngModel" [(ngModel)]="model.address.current.postCode"
                                        [pattern]="regZipCode" required />
                                    <small [ngClass]="addClass(f201,'postCode','msg')"
                                        class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                                        tabindex="-1">
                                        <span
                                            *ngIf="postCode.errors&&postCode.errors.required">กรุณาใส่รหัสไปรษณีย์</span>
                                        <span
                                            *ngIf="postCode.errors&&postCode.errors.pattern">กรุณาใส่รหัสไปรษณีย์ให้ถูกต้อง</span>
                                    </small>
                                </div>

                                <!-- รหัสไปรษณีย์ End -->

                                <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
                                    <button type="submit"
                                        class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                                        style="min-width: 300px !important;"
                                        [ngStyle]="{'background-color': style.Button}" (click)="onSaveAddr(f201)">บันทึก
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- end step four -->
    </form>
</div>

<app-loader *ngIf="!loader()"></app-loader>